import React from 'react';

/**
 * Barrière d'erreur : si un graphique lève une exception (données absentes
 * pour un scénario, champ inattendu...), on affiche un message dans la carte
 * au lieu de faire tomber toute la page.
 *
 * React n'offre pas d'équivalent en composant de fonction : les barrières
 * d'erreur doivent être des classes.
 *
 * `cle` sert à réarmer la barrière : quand elle change (changement de
 * scénario ou d'horizon), on retente le rendu plutôt que de rester bloqué
 * sur l'erreur précédente.
 */
export default class LimiteErreur extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erreur: null };
  }

  static getDerivedStateFromError(erreur) {
    return { erreur };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.cle !== this.props.cle && this.state.erreur) {
      this.setState({ erreur: null });
    }
  }

  componentDidCatch(erreur) {
    // Laisse une trace en console pour le débogage, sans casser l'affichage.
    console.error('Erreur de rendu du contenu OAD :', erreur);
  }

  render() {
    if (this.state.erreur) {
      return (
        <p className="tdb-erreur">
          {this.props.message ??
            "Ces données ne sont pas disponibles pour la sélection en cours."}
        </p>
      );
    }
    return this.props.children;
  }
}
